<template>
  <div class="help-wrap">
    <button class="help-btn" @click="open=true">i</button>
    <f7-popup :opened="open" @popup:close="open=false" class="help-popup">
      <f7-page>
        <f7-navbar :title="titulo">
          <f7-nav-left><f7-link popup-close icon-f7="xmark"></f7-link></f7-nav-left>
        </f7-navbar>
        <f7-page-content>
          <div class="help-content" v-html="contenido"></div>
        </f7-page-content>
      </f7-page>
    </f7-popup>
  </div>
</template>

<script>
export default {
  name: 'HelpButton',
  props: {
    titulo: { type: String, default: 'Ayuda' },
    contenido: { type: String, default: '' }
  },
  data: function () { return { open: false }; }
};
</script>

<style scoped>
.help-wrap{display:inline-flex;align-items:center}
.help-btn{width:28px;height:28px;border-radius:50%;background:#2563eb;color:#fff;font-weight:bold;font-size:14px;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 6px rgba(37,99,235,.3);transition:transform .15s}
.help-btn:hover{transform:scale(1.1)}
.help-popup{--f7-popup-tablet-width:80vw}
.help-content{padding:16px 20px;font-size:13px;line-height:1.7;color:#1e293b}
.help-content >>> h3{font-size:15px;font-weight:700;color:#1a2744;margin:18px 0 8px;padding-bottom:4px;border-bottom:1px solid #e2e8f0}
.help-content >>> p{margin:6px 0 10px}
.help-content >>> ul{margin:4px 0 12px;padding-left:20px}
.help-content >>> li{margin-bottom:4px}
.help-content >>> b{color:#1a2744}
</style>
